import { Box, FormField, Link, Pagination, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import React, { useEffect, useState } from 'react';
import * as XLSX from "xlsx";
import { getUser, setParameters } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemsMovement } from '../../resources/types';
import BadgeCustom from '../extras/BadgeCustom';
import SelectPaging from '../selects/selectPaging';


interface TableMovementsPaxProps {
  visible: boolean;
  filter?: boolean;
  showUser?: boolean;
  movements: ItemsMovement[];
  onSelect?: (selectedRow: any) => void; // ← optional now
  onRangeChange?: (startDate: string, endDate: string) => void; // ← optional now
  //onDismiss: () => void;
  //onConfirm: (selectedDate: string) => void;
}
const pageSize = 20;

const TableMovementsPax: React.FC<TableMovementsPaxProps> = ({
  visible,
  filter = true,
  showUser = true,
  movements,
  onSelect,
  onRangeChange
  //onDismiss,
  //onConfirm, 
}) => {

  const { parameters, data } = useGlobalState();
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [filterValue, setFilterValue] = useState("");

  const filtered: ItemsMovement[] = movements.filter((item) => {
    const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);

    // Helper function to normalize strings: remove accents and non-alphanumeric chars
    const normalize = (str: string | undefined | null) =>
      (str || "")
        .toString()
        .toLowerCase()
        .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
        .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
        .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric

    const voucherStatus = item.voucherStage === 0 ? "No iniciado" :
      item.voucherStage === 1 ? "En venta" :
        item.voucherStage === 2 ? "Vendido" :
          item.voucherStage === 3 ? "Realizado" : "Desconocido";

    // Combine all fields
    const searchableFields = [
      item.jsonMovement.email,
      item.jsonMovement.nombre,
      item.jsonMovement.movil,
      item.jsonMovement.obs,
      item.displayName,
      item.RUT,
      item.data,
      item.receipt,
      item.jsonMovement.dateProgram,
      voucherStatus,
      item.idMovement,
      item.ammount
    ];

    const text = searchableFields.map(normalize).join("");

    return searchWords.every((word) => text.includes(normalize(word)));
  });
  const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);
  useEffect(() => {
  }, [visible]);

  useEffect(() => {
    setCurrentPageIndex(1);
  }, [movements]);

  const exportToExcel = () => {
    // Convert JSON to worksheet
    const ws = XLSX.utils.json_to_sheet(filtered);

    // Create a workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Movements");

    // Generate XLSX file and download
    XLSX.writeFile(wb, "movements.xlsx");
  };
  const exportTableToPDF = (data: any[], columns: string[]) => {
    const doc = new jsPDF();

    doc.text("Movements", 14, 10);

    autoTable(doc, {
      head: [columns],
      body: data.map(row => columns.map(col => row[col])),
    });

    doc.save("movements.pdf");
  };

  const totalCargos = movements.reduce((sum, item) => {
    if (item.ammount < 0) {
      return sum + item.ammount;
    }
    return sum * -1;
  }, 0);
  const totalAbonos = movements.reduce((sum, item) => {
    if (item.ammount > 0) {
      return sum + item.ammount;
    }
    return sum;
  }, 0);

  return (
    <>

      <Table

        variant="embedded"

        stickyHeader
        filter={
          <>
            <SpaceBetween direction='horizontal' size='xs'>
              {filter ? (

                <div style={{ width: 300 }}>
                  <TextFilter countText={filterValue === "" ? `${movements.length} registros` : `${paginated.length}/${movements.length}`}
                    filteringPlaceholder="Filtrar"
                    filteringText={filterValue}
                    onChange={({ detail }) => {
                      setFilterValue(detail.filteringText);
                      setCurrentPageIndex(1);
                    }}
                  />
                </div>
              ) : undefined}
            </SpaceBetween>
          </>
        }

        pagination={

          <SpaceBetween direction="horizontal" size="xs" alignItems="center">
            {filtered.length > parameters.pageSize && (
              <Pagination
                currentPageIndex={currentPageIndex}
                pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
              />
            )}
            {movements.length > 0 && movements.length > parameters.pageSize && (
              <SelectPaging onSelect={(pageSize) => {
                setCurrentPageIndex(1);
                setParameters({ ...parameters, pageSize: pageSize });
              }} />
            )}
          </SpaceBetween>
        }
        columnDefinitions={[
          {
            id: "dateTransaction",
            header: "ID/Fecha",
            cell: item => (

              <FormField
                description={item.dateTransaction}
                label={<Link onClick={() =>
                  onSelect?.(item)
                }>{item.idMovement}</Link>}
              />
            ),
            width: 120
          },
          ...(showUser
            ? [
              {
                id: "idUser",
                header: "Comprobante",
                cell: (item: ItemsMovement) => (
                  <FormField label={item.receipt}>

                    <BadgeCustom color={item.voucherStage === 0 ? "light" : item.voucherStage === 1 ? "blue" : item.voucherStage === 2 ? "green" : item.voucherStage === 3 ? "violet" : "dark"}>
                      {item.voucherStage === 0 ? "No iniciado" : item.voucherStage === 1 ? "En venta" : item.voucherStage === 2 ? "Vendido" : item.voucherStage === 3 ? "Realizado" : "Desconocido"}{" ["}{item.voucherStage}{"]"}</BadgeCustom>
                  </FormField>

                ),
              },
            ]
            : []),
          {
            id: "data",
            header: "Glosa",
            cell: item => (

              <FormField
                description={item?.jsonMovement?.email}
                label={item?.jsonMovement?.nombre}
              />
            )
          },
          {
            id: "debit",
            header: "Monto",
            cell: item => (
              <div style={{ float: "right" }}>
                {item.ammount > 0
                  ? item.ammount.toLocaleString('es-CL', {
                    style: 'currency',
                    currency: 'CLP',
                    maximumFractionDigits: 2
                  })
                  : ""}
              </div>
            )
          },

          {
            id: "agenda",
            header: "Agendamiento",
            cell: item => (
              <FormField label={item?.jsonMovement?.dateProgram !== "" ? item?.jsonMovement?.dateProgram : "No agendado"}>
                {item?.jsonMovement?.idUser && item?.jsonMovement?.idUser > 0 ? (
                  <>
                    {getUser(item?.jsonMovement?.idUser, data)?.displayName}
                  </>
                ) : item?.jsonMovement?.mercenaries?.length === 0 ? "Sin postulantes" : item?.jsonMovement?.mercenaries?.length + " postulante" + (item?.jsonMovement?.mercenaries?.length > 1 ? "s" : "")}

              </FormField>
            )
          }
        ]}
        trackBy="idMovement"
        items={paginated ?? []}
        empty={
          <Box
            margin={{ vertical: "xs" }}
            textAlign="center"
            color="inherit"
          >
            <SpaceBetween size="m">
              <b>Sin movimientos asociados</b>
            </SpaceBetween>
          </Box>
        }
      />
    </>
  );
};

export default TableMovementsPax;